// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
import { BaleChannelPromotionDialog } from './bale-channel-promotion'

const COMPONENT_ID = 'baleChannelPromotionDialog'

export const showBaleChannelPromotionDialog = () =>
  addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: BaleChannelPromotionDialog,
  },
}
